import { __ } from '@wordpress/i18n'

export default {
  close_navigation: __('Close navigation', 'dhsv_theme'),
  close_menu: __('Close menu', 'dhsv_theme'),
  anchornavigation: __('Anchor navigation', 'dhsv_theme'),
  anchornavigation_title: __('Anchor navigation title', 'dhsv_theme'),
}
